import { z } from 'zod';
import { get } from '@namespace/helpers';
import { validateScheme } from '@namespace/helpers/src/utils/validateSchema';
import { LeaderboardResponseSchema } from './schemas';

type LeaderboardResponse = z.infer<typeof LeaderboardResponseSchema>;

export const getLeaderboard = (
  id: number | string
): Promise<LeaderboardResponse> =>
  get<LeaderboardResponse>(
    `/service/tournaments/tournaments/${id}/leaderboard`
  ).then((response) => {
    validateScheme(LeaderboardResponseSchema, response, {
      name: 'getLeaderboard'
    });

    return response;
  });
